import React from "react";
import { Edit, TextInput, LongTextInput, SelectInput, ReferenceManyField, Datagrid, TextField, NumberField, DateField, EditButton } from "admin-on-rest";
import IconTitle from "../components/icon_title";
import OlaForm from "../components/form/OlaForm";
import { province, city, kabupaten } from "./data";
import Chip from "material-ui/Chip";
import {
  red700,
  pink700,
  blue700,
  lightBlue700,
  teal700,
  green700,
  lightGreen700,
  orange800,
  deepOrange800,
  blueGrey700,
  grey700
} from "material-ui/styles/colors";
import { styles } from './styles';
const StatusField = ({ record = {} }) => {
  let colorBg = grey700;
  if (record.status === "paid") {
    colorBg = red700;
  } else if (record.status === "invoiced") {
    colorBg = teal700;
  } else if (record.status === "delivered") {
    colorBg = lightGreen700;
  } else if (record.status === "expired") {
    colorBg = deepOrange800;
  } else if (record.status === "pending payment") {
    colorBg = orange800;
  } else if (record.status === "preparing") {
    colorBg = lightBlue700;
  } else if (record.status === "out for delivery") {
    colorBg = blue700;
  } else if (record.status === "completed") {
    colorBg = green700;
  } else if (record.status === "cancelled") {
    colorBg = pink700;
  } else if (record.status === "rejected") {
    colorBg = blueGrey700;
  }

  return (
    <Chip backgroundColor={colorBg} labelColor={"#FFFFFF"} style={styles.chip}>
      <span>{record.status}</span>
    </Chip>
  );
};
class CustomerForm extends React.Component{
  constructor(props,context){
    super(props,context);
    this.state={
      provinceData:province.map((item,idx)=>{
        return {id:item,name:item};
      }),
      cityData:[],
      kabupatenData:[],
      first:true
    }
    this.handleProvinceChange=this.handleProvinceChange.bind(this);
    this.handleCityChange=this.handleCityChange.bind(this);
  }
  componentWillReceiveProps(nextProps){
    if(this.state.first){
      this.setState({first:false});
      this.handleProvinceChange(null,nextProps.record.province);
      this.handleCityChange(null,nextProps.record.city);
    }
  }
  handleProvinceChange(e,province){
    if(province)
      this.setState({cityData:city.filter(x => x.proivince === province)})
    else
      this.setState({cityData:[]});
    this.handleCityChange(e,"");
  }
  handleCityChange(e,c){
    if(c){
      var cities=city.filter(x=>x.name===c);
      if(cities.length>0)
        this.setState({kabupatenData:kabupaten.filter(x => x.cityId === cities[0].id)});
      else
        this.setState({kabupatenData:[]});
    } else
      this.setState({kabupatenData:[]});
  }
  render(){
    return (
      <OlaForm {...this.props}>
        <TextInput label="resources.customers.fieldList.first_name" source="first_name" />
        <TextInput label="resources.customers.fieldList.last_name" source="last_name" />
        <TextInput label="resources.customers.fieldList.google_email" source="email" />
        <TextInput label="resources.customers.fieldList.mobile" source="phone" />
        <LongTextInput label="resources.customers.fieldList.address" source="address" />
        <SelectInput label="resources.customers.fieldList.province" source="province" choices={this.state.provinceData} onChange={this.handleProvinceChange}/>
        <SelectInput label="resources.customers.fieldList.city" source="city" choices={this.state.cityData} onChange={this.handleCityChange} optionValue="name"/>
        <SelectInput label="resources.customers.fieldList.district" source="district" choices={this.state.kabupatenData} optionText="kabupaten" optionValue="kabupaten" />
        <TextInput label="resources.customers.fieldList.postCode" source="zip" />
        <ReferenceManyField label="Order" reference="orders" target="customer_id">
          <Datagrid>
            <TextField source="ref" label="resources.orders.fieldList.order" />
            <StatusField
              label="resources.orders.fieldList.status"
              source="status"
            />
            <NumberField
              label="resources.orders.fieldList.total"
              source="amounts.total"
              options={{ style: "currency", currency: "IDR" }}
              sortable={false}
            />
            <DateField
              style={styles.dataGridLabel}
              headerStyle={styles.dataGridHeaderLabel}
              source="created_at"
              label="resources.orders.fieldList.created_at"
              showTime
            />
            <EditButton label="" style={{ textAlign: "right" }} />
          </Datagrid>
        </ReferenceManyField>
      </OlaForm>
    )
  }
};

export const CustomerEdit = props => (
  <Edit
    {...props}
    title={<IconTitle icon="accounts" title={"resources.customers.title"} />}
  >
    <CustomerForm {...props} />
  </Edit>
);


// WEBPACK FOOTER //
// ./src/customers/Create.js